/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useWebSocket from 'react-use-websocket';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { WEBSOCKET_ADDRESS } from '../../constants';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  icons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  successIcon: {
    color: '#26A66A',
    marginLeft: 10,
  },
  waitingIcon: {
    color: '#FFCB75',
    marginLeft: 10,
  },
  failIcon: {
    color: '#E04828',
    marginLeft: 10,
  },
}));

const Confirm = ({ isConfirmed, setIsConfirmed, macAddress }) => {
  const classes = useStyles();
  const [isOverTime, setIsOverTime] = useState(false);
  const [socketUrl, setSocketUrl] = useState(`${WEBSOCKET_ADDRESS}:8080`);
  const { lastMessage } = useWebSocket(socketUrl);

  useEffect(() => {
    if (lastMessage !== null) {
      const newMessage = JSON.parse(lastMessage.data);
      newMessage.mqtt.forEach((record) => {
        if (record[3].toUpperCase() === macAddress.toUpperCase()) {
          setIsConfirmed(true);
        }
      });
    }
  }, [lastMessage, macAddress]);

  useEffect(() => {
    const closeSocket = () => setSocketUrl(null);
    window.addEventListener('beforeunload', closeSocket);
    return () => {
      window.removeEventListener('beforeunload', closeSocket);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setIsOverTime(true), [600000]);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      <h4 className={classes.title}>
        Please wait to confirm your monitor's connectivity. This may take up to 10 minutes. Once the test is complete,
        click CONTINUE.
      </h4>
      <div>
        {!isConfirmed && !isOverTime && (
          <Alert severity="warning" icon={<MoreHorizIcon />}>
            Waiting on connection
          </Alert>
        )}
        {!isConfirmed && isOverTime && (
          <Alert severity="error" icon={<CancelIcon />}>
            Connection has failed
          </Alert>
        )}
        {isConfirmed && (
          <Alert severity="success" icon={<CheckCircleIcon />}>
            Connected successfully
          </Alert>
        )}
      </div>
    </div>
  );
};

Confirm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  setIsConfirmed: PropTypes.any,
  isConfirmed: PropTypes.bool,
  macAddress: PropTypes.string,
};

Confirm.defaultProps = {
  setIsConfirmed: null,
  isConfirmed: false,
  macAddress: null,
};

export default Confirm;
